import React, { useState } from "react";
import { SLIDER_ITEMS } from "../../../store/Data";
import logo from "../../resources/images/logo.png";
import "../../styles/slider.css";

const SLIDER_DURATION = 3500;

const MainSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  React.useEffect(() => {
    const sliderInterval = setInterval(() => {
      setCurrentIndex(
        (currentIndex) => (currentIndex + 1) % SLIDER_ITEMS.length
      );
    }, SLIDER_DURATION);

    return () => {
      clearInterval(sliderInterval);
    };
  }, []);

  return (
    <section id="slider">
      {SLIDER_ITEMS.map((item, index) => (
        <div
          key={index}
          className={`slider-item image ${
            currentIndex === index ? "cnow" : ""
          }`}
          style={{
            backgroundImage: `url(${item})`,
          }}
        ></div>
      ))}
      <div className="app-logo-container">
        <img className="app-logo" src={logo} alt="tribeca" />
      </div>
    </section>
  );
};

export default MainSlider;
